import { Divider, Grid, Typography, Box } from "@mui/material";
import { InputField } from "../../../../utils/FormFields";
import PhoneField from "../../../../utils/FormFields/PhoneField";
import UploadField from "../../../../utils/FormFields/UploadField";
import { FileBodyTypeEnum } from "../../../../api/file-management";

export default function PatientAccount(props: any) {
  // const [passwordVisibility, setPasswordVisibility] = useState({ pwd: false, pwdConfirm: false });
  // const handleClickShowPassword = () => {
  //   setPasswordVisibility({ ...passwordVisibility, pwd: !passwordVisibility?.pwd });
  // };
  //
  // const handleClickShowConfirmPassword = () => {
  //   setPasswordVisibility({ ...passwordVisibility, pwdConfirm: !passwordVisibility?.pwdConfirm });
  // };
  //
  // const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   event.preventDefault();
  // };

  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Account Details
      </Typography>
      <Divider />
      <Grid container rowSpacing={3} spacing={2} sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}>
        {/*<Grid item xs={12} sm={6}>*/}
        {/*  <InputField name="User.Username" label="Username" fullWidth />*/}
        {/*</Grid>*/}
        {/*<Grid container />*/}

        <Grid item xs={12} sm={3}>
          <InputField name="User.Contact.PrimaryEmail.Email" label="Email" fullWidth />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputField name="User.Contact.SecondaryEmail.Email" label="Secondary Email" fullWidth />
        </Grid>
        <Grid container />
        {/*<Grid item xs={12} sm={6}>*/}
        {/*  <InputField*/}
        {/*    name="User.Password"*/}
        {/*    label="Password"*/}
        {/*    type={passwordVisibility.pwd ? "text" : "password"}*/}
        {/*    fullWidth*/}
        {/*    suffix={*/}
        {/*      <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">*/}
        {/*        {passwordVisibility.pwd ? <VisibilityOff /> : <Visibility />}*/}
        {/*      </IconButton>*/}
        {/*    }*/}
        {/*  />*/}
        {/*</Grid>*/}
        {/*<Grid container />*/}

        {/*<Grid item xs={12} sm={6}>*/}
        {/*  <InputField*/}
        {/*    name="User.PasswordConfirmed"*/}
        {/*    label="Password Confirmed"*/}
        {/*    type={passwordVisibility.pwdConfirm ? "text" : "password"}*/}
        {/*    fullWidth*/}
        {/*    suffix={*/}
        {/*      <IconButton*/}
        {/*        aria-label="toggle password visibility"*/}
        {/*        onClick={handleClickShowConfirmPassword}*/}
        {/*        onMouseDown={handleMouseDownPassword}*/}
        {/*        edge="end"*/}
        {/*      >*/}
        {/*        {passwordVisibility.pwdConfirm ? <VisibilityOff /> : <Visibility />}*/}
        {/*      </IconButton>*/}
        {/*    }*/}
        {/*  />*/}
        {/*</Grid>*/}
        {/*<Grid container />*/}

        <Grid item xs={12} sm={6}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <PhoneField
              name="User.Contact.PrimaryPhone.Phone"
              label="Phone Number"
              fieldName="User.Contact.PrimaryPhone.CountryCode"
            />
          </Box>
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={6}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <PhoneField
              name="User.Contact.SecondaryPhone.Phone"
              label="Second Number"
              fieldName="User.Contact.SecondaryPhone.CountryCode"
            />
          </Box>
        </Grid>
        <Grid container />

        <Grid item xs={12} sm={2}>
          <UploadField name="User.PhotoURI" label=" Photo" fullWidth fileType={FileBodyTypeEnum.PROFILEPICTURE} />
        </Grid>
      </Grid>
    </>
  );
}
